import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditSmall2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEditSmall2"><Path d="M19 0.939453L23.0607 5.00011L16.3107 11.7501H12.25V7.68945L19 0.939453Z" fill="currentColor"/><Path d="M12 3.00012H3V21.0001H21V12.0001H19.5V19.5001H4.5V4.50012H12V3.00012Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditSmall2;
